import Tooltip from '@mui/material/Tooltip';
import PARTNER_ICON_GREEN from "../utils/assets/svg/PartnerLabelGreen.svg";
import PROMOTER_ICON from "../utils/assets/svg/PromoterLabel.svg";
import PARTNER_ICON_BLACK from "../utils/assets/svg/PartnerLabelBlack.svg";

export const DisplayIcon = ({ item: item, KitchenName: KitchenName, color = 'none' }) => {

    const PartnerId = item?.invest_one?.partner_id === KitchenName
    const PromoterId = item?.invest_one?.promoter_id === KitchenName


    if (PartnerId) {

        if (color === 'green') {
            return (<div style={{ margin: '0px 0px 0px 5px', }}>
                <Tooltip
                    title="First Choice Customer"
                    placement="top"
                    arrow
                    slotProps={{
                        popper: {
                            sx: {
                                "& .MuiTooltip-tooltip": {
                                    backgroundColor: "#1e90ff",
                                    color: "white",
                                    fontSize: "12px",
                                    fontWeight: 500,

                                },
                                "& .MuiTooltip-arrow": {
                                    color: "#1e90ff",
                                },
                            },
                        },
                    }}
                >
                    <img width={20} src={PARTNER_ICON_GREEN} alt="" />
                </Tooltip>
            </div>)

        } else {
            return (<div style={{ margin: '0px 0px 0px 5px' }}>
                <Tooltip
                    title="First Choice Customer"
                    placement="top"
                    arrow
                    slotProps={{
                        popper: {
                            sx: {
                                "& .MuiTooltip-tooltip": {
                                    backgroundColor: "#1e90ff",
                                    color: "white",
                                    fontSize: "12px",
                                    fontWeight: 500,

                                },
                                "& .MuiTooltip-arrow": {
                                    color: "#1e90ff",
                                },
                            },
                        },
                    }}
                >
                    <img width={22} src={PARTNER_ICON_BLACK} alt="" />
                </Tooltip>
            </div>)
        }
    }

    if (PromoterId) {

        return (<div style={{ margin: '0px 0px 0px 5px' }}>
            <Tooltip
                title="Promoted Customer"
                placement="top"
                arrow
                slotProps={{
                    popper: {
                        sx: {
                            "& .MuiTooltip-tooltip": {
                                backgroundColor: "#1e90ff",
                                color: "white",
                                fontSize: "12px",
                                fontWeight: 500,

                            },
                            "& .MuiTooltip-arrow": {
                                color: "#1e90ff",
                            },
                        },
                    },
                }}
            >
                <img width={22} src={PROMOTER_ICON} alt="" />
            </Tooltip>
        </div>)
    }
    return null
}